if ($('.js-bannerSlider').length > 0){
	if($('.js-bannerSlider .swiper-slide').length < 2) {
		$('.js-bannerSliderPagination').hide();
	}

	const spacebetween = $('.js-bannerSlider').data('spacebetween');

	const bannerSlider = new Swiper($('.js-bannerSlider .swiper-container'), {
		speed: 600,
		spaceBetween: spacebetween || 0,
		navigation: {
			nextEl: '.js-bannerSlider .swiper-next',
			prevEl: '.js-bannerSlider .swiper-prev',
		},
		pagination: {
			el: '.js-bannerSliderPagination',
			clickable: true,
		},
	});
}
